<template>
    <b-modal ref="profile_modal"
             size="sm"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>

        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
					<span class="fw-300">

					</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show">
                <b-overlay :show="is_load" rounded="sm">
                    <div class="panel-container show">
                        <div class="panel-content mb-0">
                            <div class="user_auth">
                                <form class="user" autocomplete="off">
                                    <div class="form-group">

                                        <label class="form-label" for="input-live-feedback_username">
                                            {{__t('POSTER_SHOP_NAME')}}
                                        </label>
                                        <b-form-input
                                            id="input-live-feedback_username"
                                            :disabled="false"
                                            v-model="user_form.username"
                                            class="form-control form-control-use"
                                            placeholder="Логин заведения в системе Poster (он же будет логином в GetOrder)">
                                        </b-form-input>
                                    </div>

                                    <div class="form-group">
                                        <b-button class="btn btn-success btn-user btn-block" v-on:click="save_settings">
                                            {{__t('GO_POSTER')}}
                                        </b-button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </b-overlay>
            </div>
            <!--FOOTER -->
        </div>

        <template v-slot:modal-footer="{close}">

            <div class="modal-footer">

            </div>
        </template>


    </b-modal>
</template>

<script>
    import {createHelpers} from 'vuex-map-fields';
    const {mapFields} = createHelpers({
        getterType: 'user/getUserField',
        mutationType: 'user/updateUserField',
    });

    export default {
        name: "user_password",
        props : {
            modal_position : {
                type : String,
                default : "left"
            },
        },
        data() {
            return  {
                is_show_modal : false,
                is_load : false,
                field_type: {
                    pass: "password",
                },
                user_form : {
                    username: "",
                    phone: "",
                },
            }
        },
        created() {
            EventBus.$on("poster_refresh",this.work_click);
            this.user_form.username     = this.user.username;
            this.user_form.phone        = this.user.phone;
        },
        methods : {
            close_modal() {
                this.close()
            },
            close() {
                this.is_show_modal = false;
            },

            work_click() {
                console.log('Work ');
                this.is_show_modal = true;
            },

            async save_settings () {
                let send_data = this.user_form;

                send_data.auth_params = {
                    'poster_url' : this.user_form.username,
                    'is_internal' : true,
                };

                await api.post('/internal/user/register/poster', send_data).then(({data}) => {
                    _core.hideloading();
                    if (data.status === "operation_success") {
                        if(data.data.hasOwnProperty("redirect")) {
                            window.location.href = data.data.redirect;
                        }
                    }
                    else {
                        EventBus.$emit('show_toast', {err: this.__t('ERR'), type: "danger", title: "Нет"})
                    }
                }).catch(({response}) => {
                    _core.hideloading();
                    EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                });
            },
        },

        computed : {
            ...mapFields([
                'user',
                'module'
            ]),
            userpass_state() {
                return this.user_form.password.length > 5;
            },

            can_work () {
                return this.userpass_state;
            },

            dialog_class_draw () {
                if(this.modal_position === "left") {
                    return "modal-dialog-left modal-sm";
                }

                return "modal-dialog-right modal-sm";
            },
        }
    }
</script>

<style scoped>

</style>
